import { JarvisProduct } from '@vfde-sails/avc-core';
import { FootnotePlaceholder, ProductPlaceholder } from '../../enums/placeholder';
import { getCMSConfig } from '../cms';
import {
    PlaceholderMap,
    convertToPriceString,
    formatDeviceNamesText,
    formatReadableList,
    getLowerTariffSpeeds,
    replaceAllPlaceholders,
} from '../formatter';

export const getFootnoteCmsContent = () => {
    const { headlineText, sections } = getCMSConfig().footnoteTariffItem;

    return {
        headline: headlineText,
        content: Object.values(sections).join(''),
    };
};

const getFootnoteRegioChargeHeadlineText = (
    regioCharge: string | number = getCMSConfig().regioFeeBenefit.minimumChargeEuro
) => {
    return `+ ${convertToPriceString(regioCharge)} € Regio`;
};

const getFootnoteRegioChargeText = (
    regioCharge: string | number = getCMSConfig().regioFeeBenefit.minimumChargeEuro,
) => {
    const { regioFeeDetail } = getCMSConfig().footnoteTariffItem;

    return regioFeeDetail
        .replace(FootnotePlaceholder.REGIO_FEE_PRICE, convertToPriceString(regioCharge));
};

const getFootnoteStairwayText = (product: JarvisProduct) => {
    const { gross, month } = product.discount;
    const { discountDetail } = getCMSConfig().footnoteTariffItem;

    if (!month) {
        return '';
    }

    const priceNumber = gross;

    return replaceAllPlaceholders(discountDetail, {
        [FootnotePlaceholder.DISCOUNT_DURATION]: month.toString(),
        [FootnotePlaceholder.DISCOUNT_PRICE]: convertToPriceString(priceNumber),
    });
};

const getChangeToLowerSection = (product: JarvisProduct, tariffs: JarvisProduct[]) => {
    const lowerSpeeds = getLowerTariffSpeeds(tariffs, product.download);

    if (!lowerSpeeds.length) {
        return '';
    }

    const { headline, content } = getCMSConfig().footnoteTariffItem.wechselgarantieDetail;
    const { month } = product.discount;

    if (!month) {
        return '';
    }

    return replaceAllPlaceholders(`${headline}${content}`, {
        [FootnotePlaceholder.DISCOUNT_DURATION_END]: (1 + month).toString(),
        [FootnotePlaceholder.AVAILABLE_TARIFFS]: formatReadableList(lowerSpeeds, 'oder'),
        [FootnotePlaceholder.NEW_CONTRACT_PERIOD]: (+product.duration - month).toString(),
    });
};

export const getFootnoteHeadlineMapper = (product: JarvisProduct, regioCharge?: number): PlaceholderMap => ({
    [FootnotePlaceholder.HEADLINE_BANDWIDTH]: product.download,
    [FootnotePlaceholder.HEADLINE_REGIO_FEE]: getFootnoteRegioChargeHeadlineText(regioCharge),
});

const getFinalPrice = (product: JarvisProduct) => convertToPriceString(
    +product.price.monthly
);

export const getFootnoteContentMapper = (
    product: JarvisProduct,
    tariffs: JarvisProduct[],
    regioCharge?: number
): PlaceholderMap => ({
    [FootnotePlaceholder.PRODUCT_NAME]: product.name,
    [FootnotePlaceholder.DISCOUNT_TEXT]: getFootnoteStairwayText(product),
    [FootnotePlaceholder.FINAL_PRICE]: getFinalPrice(product),
    [FootnotePlaceholder.REGIO_FEE_TEXT]: getFootnoteRegioChargeText(regioCharge),
    [ProductPlaceholder.PROVISION_FEE]: (undefined !== product.provisionFee?.price)
        ? convertToPriceString(product.provisionFee.price) : '',
    [ProductPlaceholder.DURATION]: product.duration,
    [FootnotePlaceholder.PRODUCT_DEVICES]: formatDeviceNamesText(product),
    [FootnotePlaceholder.WECHSEL_SECTION]: getChangeToLowerSection(product, tariffs),
});
